import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "glider", "dot" ];
  glider;
  connect() {
    this.glider = new Glider(this.gliderTarget, {
      slidesToShow: 1,
      slidesToScroll: 1,
      scrollLock: true,
      draggable: true,
    });

    this.gliderTarget.addEventListener('glider-slide-visible', (event) => {
      if (this.hasDotTarget) {
        for (let element of this.dotTargets) {
          element.classList.remove('active');
        }
        this.dotTargets[event.detail.slide].classList.add('active');
      }
    });
  }

  scroll(event) {
    event.preventDefault();
    this.glider.scrollItem(event.currentTarget.dataset.scroll, true);
  }
}
